const getFooterBaseReducer = (state) => state.footer;
export const getFooter = (state) => getFooterBaseReducer(state).footerData;
export const getNewsletterState = (state) => getFooter(state).data && getFooter(state).data.subscribed;
